// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.InputChips__container-b020ec {
  list-style-type: none;
  padding: 0;
  margin: 0;
  width: 100%;
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.InputChips__list-item-bd298a {
  max-width: 100%;
}

.InputChips__item-f26632 {
  max-width: 100%;
}`, "",{"version":3,"sources":["webpack://./../../packages/ui-kit/src/InputChips/InputChips.styles.m.css"],"names":[],"mappings":"AAAA;EACE,qBAAA;EACA,UAAA;EACA,SAAA;EACA,WAAA;EACA,aAAA;EACA,QAAA;EACA,eAAA;AACF;;AAEA;EACE,eAAA;AACF;;AAEA;EACE,eAAA;AACF","sourcesContent":[".container {\n  list-style-type: none;\n  padding: 0;\n  margin: 0;\n  width: 100%;\n  display: flex;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.list-item {\n  max-width: 100%;\n}\n\n.item {\n  max-width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `InputChips__container-b020ec`,
	"list-item": `InputChips__list-item-bd298a`,
	"listItem": `InputChips__list-item-bd298a`,
	"item": `InputChips__item-f26632`
};
module.exports = ___CSS_LOADER_EXPORT___;
